import { render, staticRenderFns } from "./SwitchColumnRenderer.vue?vue&type=template&id=6e19d586&"
import script from "./SwitchColumnRenderer.vue?vue&type=script&lang=js&"
export * from "./SwitchColumnRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports